import { useMemo } from "react";
import { parseMoodTimestamp } from "utils/common/timestampUtils";
import type { Mood } from "../../../types/models";

export function usePeriodMoodFiltering(
  moods: Mood[],
  selectedPeriod: string
): Mood[] {
  const filteredMoods = useMemo((): Mood[] => {
    if (!moods || moods.length === 0) return [];
    if (!selectedPeriod) return moods;

    return moods.filter((mood: Mood) => {
      const date = parseMoodTimestamp(mood);
      if (!date || isNaN(date.getTime())) return false;

      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();
      const moodPeriod = `${month} ${year}`;
      return moodPeriod === selectedPeriod;
    });
  }, [moods, selectedPeriod]);

  return filteredMoods;
}
